module.exports = __webpack_public_path__ + "assets/img/37_386.ee56d170.jpg";